import * as React from 'react'

import IosCallOutline from 'react-ionicons/lib/IosCallOutline'
import IosCashOutline from 'react-ionicons/lib/IosCashOutline'
import { JobT } from '../../../../types/Job'


import { ContactHistoryT } from './ContactTab'
import { contactDate, yourContact } from './style'

export interface IContactTranscriptionProps {
    job: JobT
    item: ContactHistoryT
    isFirstCommunication?:boolean
}

const ContactTranscription: React.FC<IContactTranscriptionProps> = ({ job, item }) => {
    return (
        <div style={yourContact}>
            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr' }}>
                <span style={contactDate}>
                    <IosCallOutline />
                            &nbsp; &nbsp;
                            <strong>Andrea Price</strong>
                            &nbsp;&nbsp;
                            Sep 14, 2020 - 8:35 AM to 8:36 AM
                        </span>
                <span style={{ textAlign: 'right' }}>
                    <IosCashOutline
                        color='green' />
                            &nbsp;
                            Closed in <strong style={{ color: 'green' }}>10 minutes 4 seconds</strong>
                </span>
            </div>
            <hr />
            <audio src="#" controls />
            <br /><br />
            <h4>Transcription</h4>
            <div>
                <p>
                    Hello, this is Musa.  Hi Musa, it's Andrea.  This is some further conversation between the two related to closing a job.
                        </p>
            </div>
        </div>
    );
}
export default ContactTranscription;
export { ContactTranscription };